import { createSlice } from "@reduxjs/toolkit";
import {
  BlockUsersAction,
  DeleteUsersAction,
  DeleteUserSessionsAction,
  DownloadUserAllLogsAction,
  GetAllUsersAction,
  GetChatReportUserAction,
  GetUserAllFiltersAction,
  GetUserDetailAction,
  GetUserFiltersAction,
  GetUserFoldersAction,
  GetUserLabelsAction,
  GetUserSessionsAction,
  GetUserTodayLogsAction,
  InactiveUserSessionsAction,
  RestoreUsersAction,
  UnblockUsersAction,
} from "store/middlewares/user";
// isDeleteMeFulFilled
export const usersSlice = createSlice({
  name: "users",
  initialState: {
    usersLoading: true,
    users: null,
    userDetailLoading: false,
    userDetail: null,
    foldersLoading: false,
    folders: [],
    labelsLoading: false,
    labels: [],
    filtersLoading: true,
    filters: [],
    sessionsLoading: true,
    sessions: null,
    todayLogsLoading: true,
    todayLogs: null,
    allLogsLoading: true,
    allLogs: [],
    chatReportUserLoading: false,
    chatReportUser: [],
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllUsersAction.pending, (state) => {
        // state.usersLoading = state.users?.users?.length > 0 ? false : true;

        state.users = state.users?.users?.length > 0 ? state.users : null;
      })
      .addCase(GetAllUsersAction.fulfilled, (state, action) => {
        state.usersLoading = false;
        state.users = action.payload.response;
      })
      .addCase(GetAllUsersAction.rejected, (state) => {
        state.usersLoading = false;
        state.users = null;
      })

      //Delete User
      .addCase(DeleteUsersAction.fulfilled, (state, action) => {
        // state.usersLoading = false;
        // updateUser(state,action)
        state.usersLoading = false;
        state.users = action.payload.response;
      })

      // Restore User
      .addCase(RestoreUsersAction.fulfilled, (state, action) => {
        // state.usersLoading = false;
        // updateUser(state,action)
        state.usersLoading = false;
        state.users = action.payload.response;
      })

      // block User
      .addCase(BlockUsersAction.fulfilled, (state, action) => {
        // state.usersLoading = false;
        // updateUser(state,action)
        state.usersLoading = false;
        state.users = action.payload.response;
      })

      // unblock User
      .addCase(UnblockUsersAction.fulfilled, (state, action) => {
        // state.usersLoading = false;
        // updateUser(state,action)
        state.usersLoading = false;
        state.users = action.payload.response;
      })

      //user detail
      .addCase(GetUserDetailAction.pending, (state) => {
        state.userDetailLoading = true;
        state.userDetail = null;
      })
      .addCase(GetUserDetailAction.fulfilled, (state, action) => {
        state.userDetailLoading = false;
        state.userDetail = action.payload.response;
      })
      .addCase(GetUserDetailAction.rejected, (state) => {
        state.userDetailLoading = false;
        state.userDetail = null;
      })

      //user folders
      .addCase(GetUserFoldersAction.pending, (state) => {
        state.foldersLoading = false;
        state.folders = null;
      })
      .addCase(GetUserFoldersAction.fulfilled, (state, action) => {
        state.foldersLoading = false;
        state.folders = action.payload.response;
      })
      .addCase(GetUserFoldersAction.rejected, (state) => {
        state.foldersLoading = false;
        state.folders = null;
      })

      //user labels
      .addCase(GetUserLabelsAction.pending, (state) => {
        state.labelsLoading = false;
        state.labels = null;
      })
      .addCase(GetUserLabelsAction.fulfilled, (state, action) => {
        state.labelsLoading = false;
        state.labels = action.payload.response;
      })
      .addCase(GetUserLabelsAction.rejected, (state) => {
        state.labelsLoading = false;
        state.labels = null;
      })

      //user filters
      .addCase(GetUserFiltersAction.pending, (state) => {
        state.filters = null;
      })
      .addCase(GetUserFiltersAction.fulfilled, (state, action) => {
        state.filtersLoading = false;
        state.filters = action.payload.response;
      })
      .addCase(GetUserFiltersAction.rejected, (state) => {
        state.filtersLoading = false;
        state.filters = null;
      })

      //all filters
      .addCase(GetUserAllFiltersAction.pending, (state) => {
        state.filters = state.filters?.data?.length > 0 ? state.filters : null;
      })
      .addCase(GetUserAllFiltersAction.fulfilled, (state, action) => {
        state.filtersLoading = false;
        state.filters = action.payload.response;
      })
      .addCase(GetUserAllFiltersAction.rejected, (state) => {
        state.filtersLoading = false;
        state.filters = null;
      })

      //Get Sessions
      .addCase(GetUserSessionsAction.pending, (state) => {
        state.sessions =
          state.sessions?.sessions?.length > 0 ? state.sessions : null;
        state.sessionsLoading = true;
        state.sessionsLoading =
          state.sessions?.sessions?.length > 0 ? false : true;
      })
      .addCase(GetUserSessionsAction.fulfilled, (state, action) => {
        state.sessionsLoading = false;
        state.sessions = action.payload.response;
      })
      .addCase(GetUserSessionsAction.rejected, (state) => {
        state.sessionsLoading = false;
        state.sessions = null;
      })

      .addCase(InactiveUserSessionsAction.fulfilled, (state, action) => {
        state.sessionsLoading = false;
        state.sessions = action.payload.response;
      })

      .addCase(DeleteUserSessionsAction.fulfilled, (state, action) => {
        state.sessionsLoading = false;
        state.sessions = action.payload.response;
      })

      //Get todayLogs
      .addCase(GetUserTodayLogsAction.pending, (state) => {
        state.todayLogs =
          state.todayLogs?.list?.length > 0 ? state.todayLogs : null;
      })
      .addCase(GetUserTodayLogsAction.fulfilled, (state, action) => {
        state.todayLogsLoading = false;
        state.todayLogs = action.payload.response;
      })
      .addCase(GetUserTodayLogsAction.rejected, (state) => {
        state.todayLogsLoading = false;
        state.todayLogs = null;
      })

      //Get all logs
      .addCase(DownloadUserAllLogsAction.pending, (state) => {
        state.allLogsLoading = true;
        state.allLogs = [];
      })
      .addCase(DownloadUserAllLogsAction.fulfilled, (state, action) => {
        state.allLogsLoading = false;
        state.allLogs = action.payload?.response || [];
      })
      .addCase(DownloadUserAllLogsAction.rejected, (state) => {
        state.allLogsLoading = false;
        state.allLogs = [];
      })

      // Get report chat user list
      .addCase(GetChatReportUserAction.pending, (state) => {
        state.chatReportUserLoading = true;
      })
      .addCase(GetChatReportUserAction.fulfilled, (state, action) => {
        state.chatReportUserLoading = false;
        state.chatReportUser = action.payload.response;
      })
      .addCase(GetChatReportUserAction.rejected, (state) => {
        state.chatReportUserLoading = false;
        state.chatReportUser = [];
      });
  },
});

export default usersSlice.reducer;
